import { arrayOf, objectOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const isGetCanvasLastEditResult = objectOf({
  workflow_name: string,
  change_timestamps: arrayOf(number),
});
